// driveStore.ts
import { create } from "zustand";
const useDriveStore = create((set, get) => ({
    selectedFiles: [],
    subModeRequest: null,
    setSubModeRequest: (request) => set({ subModeRequest: request }),
    setSelectedFiles: (files) => set({ selectedFiles: files }),
    addFile: (file) => set((state) => ({
        selectedFiles: [...state.selectedFiles, file]
    })),
    removeFile: (fileId) => set((state) => ({
        selectedFiles: state.selectedFiles.filter((file) => file.id !== fileId)
    })),
    clearSelectedFiles: () => set({ selectedFiles: [] }),
    isFileSelected: (fileId) => get().selectedFiles.some((file) => file.id === fileId)
}));
export default useDriveStore;
